// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Ua+cP","content":"styles_content__rVeFP","info":"styles_info__G4N3j","details":"styles_details__MFKci","noimage":"styles_noimage__plwUp"};